import { css } from '@/styled-system/css';
import { token } from '@/styled-system/tokens';

const MOBILE_HEADER_HEIGHT = token('sizes.1200');

export const detailHubContainer = css({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'bg.neutral',
  position: 'relative',
  minHeight: '100vh',
  '@supports (min-height: 100dvh)': {
    minHeight: '100dvh',
  },
  lg: {
    minHeight: 'unset',
  },
});

export const detailHeader = css({
  '--hdp-detail-header-opacity': '0%',
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingInline: 'default',
  paddingBlock: 'default',
  minHeight: MOBILE_HEADER_HEIGHT,
  backgroundColor: `color-mix(in srgb, ${token.var('colors.bg.neutral')} var(--hdp-detail-header-opacity), transparent)`,
  borderBottomWidth: 'default',
  borderBottomStyle: 'solid',
  borderBottomColor: `color-mix(in srgb, ${token.var('colors.border.neutral')} var(--hdp-detail-header-opacity), transparent)`,
  zIndex: 'zIndexOverParent',
  willChange: 'transform',
  transitionProperty: 'background-color, border-bottom-color, box-shadow',
  transitionDuration: '0.3s',
  transitionTimingFunction: 'ease-out',
  lg: {
    display: 'none',
  },
});

export const detailHeaderSurfaced = css({
  boxShadow: '{colors.effect.elevation.sm}',
});

export const headerActions = css({
  display: 'flex',
  gap: 'default',
  alignItems: 'center',
});

export const detailMainContent = css({
  flex: 1,
  position: 'relative',
  lg: {
    display: 'flex',
    flexDirection: 'column',
  },
});

// Body surface for the route-native HDP. Document scroll owns the page; the
// desktop map stays sticky beside it in the shared search shell.
export const detailScrollArea = css({
  lg: {
    scrollbarGutter: 'stable',
  },
});

export const detailBody = css({
  width: '100%',
});

export const mobileHeaderBackButton = css({
  flexShrink: 0,
});

export const detailFooter = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 'tighter',
  padding: 'default',
  backgroundColor: 'bg.neutral',
  borderTopWidth: 'default',
  borderTopStyle: 'solid',
  borderTopColor: 'border.neutral',
  minHeight: '1800',
  position: 'sticky',
  bottom: 0,
  zIndex: 'zIndexStep',
  lg: {
    display: 'none',
  },
});

export const spokeFooterActions = css({
  display: 'flex',
  gap: 'tighter',
  width: '100%',
  // eslint-disable-next-line hotpads/no-magic-numbers -- caps sticky footer CTAs to the designed mobile button group width
  maxWidth: '400px',
});
